import type { RecruitAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { WarchestState } from "../types/game-state";
import { hasCoin } from "../utils/zone-utils";

export function validateRecruit(
  state: WarchestState,
  action: RecruitAction,
): ValidationResult {
  if (state.phase !== "USE_COINS") {
    return { valid: false, error: "Not in USE_COINS phase" };
  }
  if (action.player !== state.activePlayer) {
    return { valid: false, error: "Not your turn" };
  }
  const zones = state.playerZones[action.player];
  if (!hasCoin(zones, action.coinType, "hand")) {
    return { valid: false, error: "Coin not in hand" };
  }
  if (!hasCoin(zones, action.recruitCoinType, "supply")) {
    return { valid: false, error: "Recruit coin not in your supply" };
  }
  return { valid: true };
}
